<template>
    <modal name="lookbook-item-create-modal" class="item-modal dgm-modal"
           :width="'800px'"
           :height="'300px'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="lookbook_item_wrap">
            <div class="li_title">엑셀 등록</div>
            <button class="close_btn" @click="modalClose"></button>
            <excel-lookbook-item-component :lookbook-key="lookbookKey"></excel-lookbook-item-component>

            <div class="mt40" style="text-align: center;">
                <el-button @click="submitExcel()" type="primary">등록</el-button>
            </div>
        </div>
    </modal>

</template>

<script>
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import ExcelLookbookItemComponent from "@/components/excel/ExcelLookbookItemComponent";

export default {
    name: 'LookbookItemCreateModal',
    props: {},
    mixins: [],
    components: {ExcelLookbookItemComponent},
    computed: {},
    provide() {
        return {}
    },
    data() {
        return {
            lookbookKey: '',
        }
    },
    mounted() {

    },
    methods: {
        handlerBeforeOpen(event) {

            if (!util.isEmpty(event.params) && !util.isEmpty(event.params.lookbookKey)) {
                this.lookbookKey = event.params.lookbookKey;
            }

        },
        handlerOpened() {
        },
        handlerBeforeClose() {
            this.lookbookKey = '';
        },
        modalClose() {
            this.$modal.hide('lookbook-item-create-modal');
        },
        submitExcel() {
            EventBus.$emit('writeExcel');
        }
    }
}
</script>
